export default class CredentialsError extends Error {
    static error;

    constructor(error) {
        super();
        this.error = error;
    }
}
